/**
 * @generated SignedSource<<933cbbd0083e6778c8b36ad6ca88f28d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceWorkWithMe_productizedService$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ServiceInquiryButton_productizedService" | "useProductizedServicePreview_productizedService">;
  readonly " $fragmentType": "ProductizedServiceWorkWithMe_productizedService";
};
export type ProductizedServiceWorkWithMe_productizedService$key = {
  readonly " $data"?: ProductizedServiceWorkWithMe_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceWorkWithMe_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceWorkWithMe_productizedService",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useProductizedServicePreview_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServiceInquiryButton_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "0dba862ad093ca3fdb0da858c8ac8a09";

export default node;
